import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ga',
    fullName: 'Irish',
    nativeName: 'Gaeilge',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Tá Rud Iontach ag Teacht",
    landing_subtitle: "Is stiúideo forbartha aipeanna agus cluichí é ArgVoid. Bígí ag súil, tá rudaí nua ag teacht go luath!",
    select_language: "Roghnaigh Teanga",
    search_placeholder: "Cuardaigh teangacha...",
    terms_title: "Téarmaí Seirbhíse",
    policy_title: "Beartas Príobháideachta",
    cookies_title: "Polasaí Fianán",
    terms_content: `
        <strong>1. Glacadh le Téarmaí</strong><br>
        Trí rochtain a fháil ar ArgVoid, glactar leis na Téarmaí Seirbhíse seo. Mura n-aontaítear leis na téarmaí seo, níor cheart an tseirbhís a úsáid.<br><br>

        <strong>2. Úsáid Ardáin</strong><br>
        Soláthraítear ArgVoid agus a fheidhmchláir "mar atá" chun críocha faisnéise agus cruthaitheacha. Ní mór an tseirbhís a úsáid chun críocha dleathacha amháin.<br><br>

        <strong>3. Iompar Toirmiscthe</strong><br>
        Tá cosc iomlán ar leochaileachtaí an tsuímh a shaothrú, ar thurscar nó ar rochtain neamhúdaraithe ar an mbonneagar a thriail.<br><br>

        <strong>4. Séanadh</strong><br>
        Féadfar an t-ardán agus na seirbhísí a mhodhnú am ar bith gan fógra. Ní thugtar aon bharántas maidir le ham aga fónaimh ná le hinfhaighteacht na seirbhíse.
    `,
    policy_content: `
        <strong>1. Bailiúchán Faisnéise</strong><br>
        Níl fíordheimhniú úsáideora ná cruthú cuntais ag teastáil ón ardán faoi láthair. Ní bhailítear go gníomhach aon fhaisnéis aitheantais phearsanta (amhail ainmneacha nó seoltaí ríomhphoist) ó chuairteoirí.<br><br>

        <strong>2. Sonraí Úsáide</strong><br>
        Féadfar anailísí bunúsacha gan ainm a bhailiú chun trácht suímh a thuiscint agus chun na feidhmchláir a fheabhsú. Níl na sonraí seo nasctha le haitheantais úsáideora aonair.<br><br>

        <strong>3. Seirbhísí Tríú Páirtí</strong><br>
        Féadfar soláthraithe tríú páirtí a úsáid le haghaidh seirbhísí óstála agus anailíse. Rialaíonn cleachtais phríobháideachta na soláthróirí seo faoi seach na sonraí gan ainm a phróiseáiltear ar a mbonneagar.<br><br>

        <strong>4. Slándáil Sonraí</strong><br>
        Cuirtear bearta slándála réasúnta i bhfeidhm chun an t-ardán a chosaint. Mar sin féin, níl aon mhodh tarchuir thar an Idirlíon slán iomlán.<br><br>
    `,
    cookies_content: `
        <strong>1. Cad is Fianáin agus Stóráil Áitiúil ann?</strong><br>
        Is comhaid bheaga sonraí iad fianáin agus stóráil áitiúil brabhsálaí a stóráiltear ar an ngléas chun sainroghanna cumraíochta thar chuairteanna a mheabhrú.<br><br>

        <strong>2. Úsáid Cuspóir</strong><br>
        Úsáidtear Brabhsálaí LocalStorage go docht chun socruithe cumraíochta a shábháil, mar: <br>
        - Roghanna teanga<br>
        - Cumraíocht an chomhéadain úsáideora (m.sh., leagan amach nó socruithe téama) <br>
        - Iarratas sealadach cache<br><br>

        <strong>3. Gan Rianú</strong><br>
        Ní úsáidtear fianáin agus stóráil áitiúil chun críocha fógraíochta nó rianú tríú páirtí. Tá na sonraí go léir stóráilte go docht le haghaidh feidhmiúlacht lárnach an ardáin.<br><br>

        <strong>4. Rialú</strong><br>
        Is féidir sonraí an bhrabhsálaí a ghlanadh ag am ar bith trí shocruithe an bhrabhsálaí, rud a athshocróidh aon chumraíochtaí áitiúla.
    `,
    cookie_consent_text: "Bainimid úsáid as fianáin bhunúsacha chun a chinntiú go bhfeidhmíonn an suíomh Gréasáin i gceart, mar shampla do sheisiún a choinneáil gníomhach, do rogha teanga a shábháil, agus cumraíochtaí saincheaptha eile.",
    read_policy: "Léigh Polasaí Fianán",
    support_title: "Tacaíocht Teagmhála",
    support_subject_label: "Ábhar",
    support_message_label: "Teachtaireacht",
    support_submit_button: "Seol Teachtaireacht",
    support_hint: "Nóta: Osclóidh sé seo d'iarratas ríomhphoist réamhshocraithe chun an teachtaireacht a sheoladh.",
    support_success_msg: "Ag oscailt d'aip ríomhphoist...",
    support_error_msg: "Theip ar an teachtaireacht a sheoladh. Bain triail eile as ar ball.",
    explorer_title: "taiscéalaí",
    history_title: "Stair",
    animation_title: "Beochan",
    config_title: "Cumraíocht",
    tool_mouse: "Roghnaigh (Ctrl+M)",
    tool_brush: "Scuab (Ctrl+B)",
    tool_brush_mode: "Mód Scoránaigh (Soladach/Glan)",
    tool_eraser: "Scriosán (Ctrl+E)",
    tool_brush_size: "Coigeartaigh Méid Scuab",
    tool_bucket: "Líon (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Greille (Ctrl+Shift+B)",
    tool_rotate: "Rothlaigh (Ctrl+Shift+R)",
    tool_flip_h: "Smeach H (Ctrl+Shift+H)",
    tool_flip_v: "Smeach V (Ctrl+Shift+V)",
    tool_transpose: "Trasnaigh (Ctrl+Shift+T)",
    label_width: "Leithead",
    label_height: "Airde",
    label_frames: "Líon Frámaí",
    label_animation: "Stíl Beochana",
    label_background_color: "Dath an Chúlra",
    label_interval: "Eatramh",
    tool_anim_config: "Cumraíocht Beochana",
    label_new_width: "Leithead Nua",
    label_new_height: "Airde Nua",
    label_apply: "Cuir iarratas isteach",
    label_colors: "Dathanna",
    label_size: "Méid",
    label_tolerance: "Caoinfhulaingt",
    val_horizontal: "Cothrománach",
    val_vertical: "Ingearach",
    val_sequence: "Seicheamh",
    val_bounce: "Preab",
    val_random: "randamach",
    val_solid: "Soladach",
    val_clear: "Glan",
    action_add_sheet: "Bileog Nua",
    action_import: "Iompórtáil",
    action_export: "Easpórtáil",
    action_sort_projects: "Sórtáil",
    sort_date_old: "Is sine ar dtús",
    sort_date_new: "Is Déanaí ar dtús",
    sort_name_az: "Ainm (AZ)",
    sort_name_za: "Ainm (Z-A)",
    action_new_sprite: "Sprite Nua",
    action_new_project: "Tionscadal Nua",
    modal_save_all_title: "Sábháil Gach Athrú",
    modal_save_all_desc: "Roghnaigh na sócmhainní le sábháil:",
    modal_save_selected: "Sábháil Roghnaithe",
    action_saved: "Shábháil",
    modal_create_sprite_title: "Cruthaigh Sprite Nua",
    modal_create_project_title: "Cruthaigh Tionscadal Nua",
    modal_add_sheet_title: "Cuir Bileog Nua leis",
    modal_rename_sheet_title: "Athainmnigh an Bhileog",
    modal_rename_sprite_title: "Athainmnigh Sprite",
    modal_delete_sprite_title: "Scrios Sprite",
    modal_delete_project_title: "Scrios Tionscadal",
    modal_delete_sheet_title: "Scrios Bileog",
    placeholder_sprite_name: "Ainm",
    placeholder_project_name: "Ainm",
    placeholder_sheet_name: "Ainm",
    placeholder_new_name: "Ainm Nua",
    action_create: "Cruthaigh",
    action_add: "Cuir",
    action_rename: "Athainmnigh",
    action_duplicate: "Dúblach",
    action_delete: "Scrios",
    action_cancel: "Cealaigh",
    confirm_delete_sprite: "An bhfuil tú cinnte gur mhaith leat an sprite seo a scriosadh?",
    confirm_delete_project: "An bhfuil tú cinnte gur mhaith leat an tionscadal seo a scriosadh? Bainfear gach sprites.",
    confirm_delete_sheet: "An bhfuil tú cinnte gur mhaith leat an bhileog seo a scriosadh?",
    err_select_sprite: "Roghnaigh sprite ar dtús.",
    err_select_project: "Roghnaigh tionscadal ar dtús.",
    err_name_empty: "Ní féidir leis an ainm a bheith folamh.",
    err_sprite_exists: "Tá sprite leis an ainm sin ann cheana féin.",
    err_project_exists: "Tá tionscadal leis an ainm sin ann cheana féin.",
    err_no_content: "Níl aon ábhar le sábháil.",
    err_no_changes: "Níl aon athruithe le sábháil.",
    err_delete_last_sheet: "Ní féidir an leathán deiridh a scriosadh.",
    err_extract_frames: "Níorbh fhéidir aon fhráma a bhaint as.",
    err_indexeddb: "Theip ar shábháil go háitiúil. Seans nach dtacaíonn do bhrabhsálaí le IndexedDB.",
    msg_upload_success: "D'éirigh leis an Uaslódáil: {0}",
    msg_upload_failed: "Theip ar an Uaslódáil: {0}",
    msg_save_success: "Sábháil rathúil.",
    msg_saving: "Ag sábháil...",
    msg_multi_save_result: "Sócmhainn {0} sábháilte. {1} teip.",
    menu_title: "Roghchlár",
    menu_save: "Sábháil",
    menu_save_all: "Sábháil Uile",
    menu_support: "Tacaíocht Teagmhála",
    label_local_storage: "Stóráil Áitiúil",
    label_sign_in: "Sínigh Isteach",
    modal_export_title: "Easpórtáil Sprite",
    label_filename: "Ainm comhaid",
    label_format: "Formáid",
    action_export_confirm: "Easpórtáil",
};

export default translations;
